module.exports = __webpack_public_path__ + "img/2019qinglongxia-4.5ec450f3.jpg";